import CryptoAES from 'crypto-js/aes';
import CryptoENC from 'crypto-js/enc-utf8';

const ENCRYPTION_KEY: string = process.env.REACT_APP_ENCRYPTION_KEY || '';

export const encrypt = (data = '') =>
  CryptoAES.encrypt(JSON.stringify(data), ENCRYPTION_KEY).toString();

export const decrypt = (data = '') => {
  if (data) {
    const decryptedValue = CryptoAES.decrypt(data, ENCRYPTION_KEY).toString(
      CryptoENC,
    );
    let result = decryptedValue;

    try {
      result = JSON.parse(decryptedValue);
    } catch (error) {}

    return result;
  }

  return '';
};
